export var PdfModalType;
(function (PdfModalType) {
    PdfModalType["Analysis"] = "Analysis";
    PdfModalType["Grid"] = "Grid";
    PdfModalType["SectionAnalysis"] = "SectionAnalysis";
    PdfModalType["Widget"] = "Widget";
})(PdfModalType || (PdfModalType = {}));
